import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatomoModule } from 'ngx-matomo-client'

import { CoreModule, Config, CoreService } from 'core';
import { HomeComponent } from './pages/home/home.component';
import { HelloComponent } from './pages/hello/hello.component';
import { SplashComponent } from './pages/splash/splash.component';
import { TourComponent } from './pages/tour/tour.component';
import { ActiveTourComponent } from './pages/active-tour/active-tour.component';
import { MapComponent } from './pages/map/map.component';
import { SearchComponent } from './pages/search/search.component';
import { IonicModule } from '@ionic/angular';
import { EventsComponent } from './pages/events/events.component';
import { EventComponent } from './pages/event/event.component';
import { ToursComponent } from './pages/tours/tours.component';
import { ArComponent } from './pages/ar/ar.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { ItemComponent } from './pages/item/item.component';
import { InfoComponent } from './pages/info/info.component';
import { ExhibitComponent } from './pages/exhibit/exhibit.component';
import { LoadingComponent } from './pages/loading/loading.component';
import { CollectionsComponent } from './pages/collections/collections.component';
import { VideosComponent } from './pages/videos/videos.component';
import { CollectionsItemsComponent } from './pages/collections-items/collections-items.component';
import { ArListComponent } from './pages/ar-list/ar-list.component';
import { ExhibitListComponent } from './pages/exhibit-list/exhibit-list.component';
import { PermissionsComponent } from './pages/permissions/permissions.component';
import { SiteSectionComponent } from './pages/site-section/site-section.component';
import { SiteSectionListComponent } from './pages/site-section-list/site-section-list.component';
import { TriviaComponent } from './pages/trivia/trivia.component';
import { DigitalQueueComponent } from './pages/digital-queue/digital-queue.component';
import { DigitalQueueListComponent } from './pages/digital-queue-list/digital-queue-list.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HelloComponent,
    SplashComponent,
    TourComponent,
    ActiveTourComponent,
    MapComponent,
    SearchComponent,
    EventsComponent,
    EventComponent,
    ToursComponent,
    ArComponent,
    SettingsComponent,
    ItemComponent,
    CollectionsComponent,
    InfoComponent,
    ExhibitComponent,
    LoadingComponent,
    VideosComponent,
    CollectionsItemsComponent,
    ArListComponent,
    ExhibitListComponent,
    PermissionsComponent,
    SiteSectionComponent,
    SiteSectionListComponent,
    TriviaComponent,
    DigitalQueueComponent,
    DigitalQueueListComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    IonicModule.forRoot({}),
    CoreModule.forRoot({
      appId: "78",
      apiUrl: "https://prx.webapp.gurumuseumsystems.com/v1/",
      // apiUrl: "http://192.168.68.58:8000/api/museum/v1/",
      // apiUrl: "https://prx.webapp.guruexperience.info/v1/",
      arManifestRoot: "https://api.ar.gurumuseumsystems.com/config/current-manifest/",
      arAppId: "78",
      arApiUrl: "https://api.ar.guruexperience.co",
      navApiUrl: 'https://nav.webapp.gurumuseumsystems.com/v2/',
      geolocationHelpLink: "https://locationservices.guruwebapp.com/"
  
      // navApiUrl: 'https://nav.webapp.guruexperience.info/v2/'

    }),
    MatomoModule.forRoot({
      siteId: 12,
      trackerUrl: "https://ax.data.guruexperience.co/"
    }),
  ],
  providers: [
    CoreService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
